import PropTypes from "prop-types";
import { CustomContainer } from "../../../DependencyHelper";
import formStyles from "../CreditCheckDetails.module.scss";

const ContactDetailsInfo = ({ data }) => {
  return (
    <CustomContainer className={`${formStyles["form-details-container"]}`}>
      <CustomContainer className="row">
        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Cellphone number:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.cellNumber}</span>
        </CustomContainer>

        <CustomContainer className={`${formStyles["pb-6"]} col-md-6 col-sm-12`}>
          <label>Email address:</label>
        </CustomContainer>
        <CustomContainer className={`col-md-6 col-sm-12`}>
          <span>{data?.emailAddress}</span>
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  );
};

ContactDetailsInfo.propTypes = {
  data: PropTypes.object,
};

ContactDetailsInfo.defaultProps = {
  data: {},
};

export default ContactDetailsInfo;
